// shadcn/ui Button (Radix variant), scoped to the landing page's Tailwind prefix.
import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva, type VariantProps } from 'class-variance-authority';
import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';
const merge = extendTailwindMerge({ prefix: 'lp-' });
export function cn(...inputs: ClassValue[]) { return merge(clsx(inputs)); }
const buttonVariants = cva(
  'lp-inline-flex lp-items-center lp-justify-center lp-gap-2 lp-whitespace-nowrap lp-rounded-full lp-text-sm lp-font-medium lp-transition-colors focus-visible:lp-outline-none focus-visible:lp-ring-2 focus-visible:lp-ring-ring focus-visible:lp-ring-offset-2 disabled:lp-pointer-events-none disabled:lp-opacity-50',
  { variants: {
    variant: {
      default: 'lp-bg-primary lp-text-primary-foreground hover:lp-bg-primary/90',
      outline: 'lp-border lp-border-border lp-bg-background hover:lp-bg-secondary',
      ghost: 'lp-bg-transparent lp-text-foreground hover:lp-bg-secondary',
    },
    size: { default: 'lp-h-11 lp-px-6', sm: 'lp-h-10 lp-px-5', icon: 'lp-h-11 lp-w-11' },
  }, defaultVariants: { variant: 'default', size: 'default' } },
);
export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof buttonVariants> { asChild?: boolean }
export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : 'button';
  return <Comp className={cn(buttonVariants({ variant, size, className }))} ref={ref} {...props} />;
});
Button.displayName = 'Button';
